import script from "./ProductDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__